var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"locked-option"},[_vm._m(0),_vm._v(" "),_c('span',{staticClass:"locked-option-text"},[_vm._v("\n    "+_vm._s(_vm.label)+"\n  ")])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"btn-xs btn-danger lock-icon"},[_c('i',{staticClass:"fa fa-lock",attrs:{"title":"Locked: Premium Only"}})])
}]

export { render, staticRenderFns }